import PrivacyInformation from 'src/components/ConnectedVehicle/PrivacyInformation/PrivacyInformation';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    connectedVehicle: state.ConnectedVehicle.ConnectedVehicleRec,
});

export default connect(mapStateToProps)(PrivacyInformation);